// privacyPolicyText.js
const privacyPolicyText = [
    {
        title: "1. Introduction",
        content: "We are committed to protecting your personal information and ensuring your privacy. This policy explains how we collect, use, and protect your data during the registration process and throughout your use of our system."
    },
    {
        title: "2. Data We Collect",
        content: "When you register as a doctor, we may collect the following personal information: full name, surname, fiscal code, email address, registration number, specialization, and password."
    },
    {
        title: "3. Purpose of Data Collection",
        content: "Your data is collected to verify your identity, manage your account, and ensure secure access to our system. It is also used for communication purposes."
    },
    {
        title: "4. Data Protection and Security",
        content: "We implement various security measures, including encryption, access control, and regular audits, to protect your personal data."
    },
    {
        title: "5. Data Sharing",
        content: "Your personal data will not be shared with third parties unless required by law or with your explicit consent."
    },
    {
        title: "6. Your Rights",
        content: "You have the right to access, modify, or delete your personal information. Contact support to exercise these rights."
    },
    {
        title: "7. Cookies and Tracking",
        content: "We may use cookies and tracking technologies to enhance your experience and improve our services."
    },
    {
        title: "8. Changes to the Privacy Policy",
        content: "We may update this policy periodically. Please review this page regularly for updates."
    },
    {
        title: "9. Contact Us",
        content: "If you have any questions, please contact us at: support@example.com"
    }
];

export default privacyPolicyText;
